// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../_base.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../ui/styles/tavern-components.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== Events Dashboard - Tavern Theme ========== */

.events-dashboard {
  padding: var(--space-4);
  max-width: 960px;
  margin: 0 auto;
}

.events-dashboard-header {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  flex-wrap: wrap;
  margin-bottom: var(--space-4);
}

.events-dashboard-title {
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: var(--font-weight-bold);
  color: var(--color-fire-600);
  margin: 0;
  display: flex;
  align-items: center;
  gap: var(--space-2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.events-create-button {
  margin-left: auto;
  font-size: 14px;
  padding: 10px 16px;
  height: auto;
  width: auto;
  white-space: nowrap;
}

/* Date Range Controls */
.events-date-range,
.date-range-control {
  background: var(--color-wood-800);
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
  padding: var(--space-2) var(--space-3);
  /* margin-bottom: var(--space-4); */
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-3);
}

.events-date-range-info,
.date-range-text {
  font-size: 16px;
  font-weight: 700;
  color: var(--color-parchment-100);
  text-align: center;
  font-variant-numeric: tabular-nums;
  font-family: var(--font-heading);
}

.date-range-button {
  background: var(--color-wood-700);
  border: 2px solid var(--color-wood-600);
  color: var(--color-parchment-200);
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.date-range-button:hover {
  background: var(--color-wood-600);
  border-color: var(--color-fire-600);
}

.date-range-button--today {
  background: var(--color-fire-700);
  border-color: var(--color-fire-600);
  color: var(--color-parchment-100);
}

.date-range-button--today:hover {
  background: var(--color-fire-600);
  border-color: var(--color-fire-500);
}

@media (max-width: 425px) {
  .events-date-range {
    flex-direction: column;
  }
  
  .events-date-range .tavern-btn-secondary {
    width: 100%;
  }
}

/* Events Content */
.events-content {
  min-height: 300px;
}

/* Day Header */
.day-header {
  background: var(--color-wood-800);
  color: var(--color-parchment-100);
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: 600;
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-lg);
  margin-top: var(--space-6);
  margin-bottom: var(--space-4);
  position: sticky;
  top: 0;
  z-index: 10;
  cursor: pointer;
  user-select: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all var(--transition-fast);
}

.day-header-wrapper {
  cursor: pointer;
  position: relative;
  /* Button reset for accessibility */
  width: 100%;
  border: none;
  background: transparent;
  padding: 0;
  text-align: left;
  font: inherit;
}

.day-header-arrow {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px;
  font-weight: normal;
  color: var(--color-fire-500);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
  transition: transform 0.3s ease;
  z-index: 100;
  pointer-events: none;
  line-height: 1;
}

.day-header-arrow--collapsed {
  transform: translateY(-50%) rotate(180deg);
}

.day-header:hover {
  background: var(--color-wood-700);
}

.day-header::after {
  content: '▼';
  font-size: 14px;
  transition: transform var(--transition-fast);
}

.day-header.collapsed::after {
  transform: rotate(-90deg);
}

/* Day Content */
.day-content {
  max-height: 10000px;
  overflow: hidden;
  transition: max-height 0.4s ease-out, opacity 0.3s ease-out;
  opacity: 1;
}

.day-content.collapsed {
  max-height: 0;
  opacity: 0;
}

/* Table Subheader */
.table-subheader {
  background: linear-gradient(135deg, var(--color-wood-700) 0%, var(--color-wood-800) 100%);
  color: var(--color-parchment-100);
  font-size: 16px;
  font-weight: 700;
  padding: var(--space-1) var(--space-2);
  border: none;
  border-left: 5px solid var(--color-fire-500);
  margin: var(--space-1) 0 var(--space-1) var(--space-1);
  border-radius: 12px;
  cursor: pointer;
  user-select: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all var(--transition-fast);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
  /* Button reset for accessibility */
  width: calc(100% - var(--space-3));
  text-align: left;
  font-family: inherit;
}

.table-subheader:hover {
  background: linear-gradient(135deg, var(--color-wood-600) 0%, var(--color-wood-700) 100%);
  transform: translateX(4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.15);
}

.table-subheader::after {
  content: '▼';
  font-size: 14px;
  color: var(--color-fire-400);
  transition: transform var(--transition-fast);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
}

.table-subheader.collapsed::after {
  transform: rotate(-90deg);
}

/* Table Content */
.table-content {
  margin-left: var(--space-4);
  max-height: 10000px;
  overflow: hidden;
  transition: max-height 0.4s ease-out, opacity 0.3s ease-out;
  opacity: 1;
}

@media (min-width: 768px) {
  .table-content:not(.collapsed) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--space-3);
    align-items: start;
  }

  .table-content .table-subheader,
  .table-content .type-subheader {
    grid-column: 1 / -1;
  }
}

@media (min-width: 1024px) {
  .events-dashboard {
    max-width: var(--content-max);
    padding: var(--space-6) var(--space-7);
  }

  /* Карточки одного типа в день — в сетку, а не в одну растянутую колонку */
  .type-content {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: var(--space-4);
    align-items: start;
  }

  .type-content > .tavern-card--event {
    margin-bottom: 0;
  }

  .table-content:not(.collapsed) {
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  }
}

.table-content.collapsed {
  max-height: 0;
  opacity: 0;
}

/* Event Cards (from prototype) */
.event-card {
  background: var(--color-parchment-100);
  
  /* Parchment texture */
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%),
    repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(139, 69, 19, 0.06) 2px, rgba(139, 69, 19, 0.06) 3px),
    repeating-linear-gradient(90deg, transparent, transparent 100px, rgba(160, 82, 45, 0.03) 100px, rgba(160, 82, 45, 0.03) 101px);
  
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
  padding: var(--space-4);
  margin-bottom: var(--space-3);
  transition: all var(--transition-normal);
}

.event-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.event-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: var(--space-3);
}

.event-badges {
  display: flex;
  gap: var(--space-2);
}

.event-badge {
  background: var(--color-wood-700);
  color: white;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 12px;
  text-transform: uppercase;
}

.event-badge-open {
  background: var(--color-success-500);
}

.event-time {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-secondary);
}

.event-title {
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: 700;
  color: var(--color-fire-600);
  margin-bottom: var(--space-2);
}

.event-organizer {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin-bottom: var(--space-3);
}

.event-slots {
  border-top: 1px solid var(--color-wood-600);
  padding-top: var(--space-3);
}

/* Type subheader (boardgames / ping_pong / fencing) within a day */
.type-section {
  margin-bottom: var(--space-3);
}

.type-subheader {
  background: linear-gradient(135deg, var(--color-wood-700) 0%, var(--color-wood-800) 100%);
  color: var(--color-parchment-100);
  font-size: 15px;
  font-weight: 700;
  padding: var(--space-1) var(--space-2);
  border: none;
  border-left: 5px solid var(--color-fire-500);
  margin: var(--space-1) 0 var(--space-1) var(--space-1);
  border-radius: 12px;
  width: calc(100% - var(--space-3));
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
}

.type-content {
  margin-left: var(--space-4);
}

/* Legacy compatibility classes */
.ttbEventsDashboardPage {
  padding: var(--space-4);
  max-width: 960px;
  margin: 0 auto;
}

.ttbSubTitle {
  /* This is now replaced by tavern-table-header */
  font-size: 14px;
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary-light);
}

.ttbRangeControls {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  margin-bottom: var(--space-5);
  padding: var(--space-4);
  background: var(--color-wood-800);
  border-radius: var(--radius-lg);
  border: 2px solid var(--color-wood-700);
}

@media (max-width: 425px) {
  .ttbEventsDashboardPage .ttbRangeControls {
    gap: 8px;
    flex-direction: column;
  }

  .ttbEventsDashboardPage .ttbRangeControls .ttbGrow {
    flex-basis: 100%;
    width: 100%;
  }
}


`, "",{"version":3,"sources":["webpack://./src/pages/EventsDashboard/EventsDashboardPage.css"],"names":[],"mappings":"AAGA,0DAA0D;;AAE1D;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,oCAAoC;EACpC,4BAA4B;EAC5B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;;EAEE,iCAAiC;EACjC,uCAAuC;EACvC,+BAA+B;EAC/B,sCAAsC;EACtC,mCAAmC;EACnC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,iCAAiC;EACjC,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,iCAAiC;EACjC,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,+BAA+B;EAC/B,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,yCAAyC;EACzC,+BAA+B;EAC/B,YAAY;EACZ,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2DAA2D;EAC3D,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,yFAAyF;EACzF,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,YAAY;EACZ,4CAA4C;EAC5C,sDAAsD;EACtD,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;EACtC,gFAAgF;EAChF,yCAAyC;EACzC,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,yFAAyF;EACzF,0BAA0B;EAC1B,kFAAkF;AACpF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,2DAA2D;EAC3D,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;IACb,gDAAgD;IAChD,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,sCAAsC;EACxC;;EAEA,0EAA0E;EAC1E;IACE,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA,iCAAiC;AACjC;EACE,sCAAsC;;EAEtC,sBAAsB;EACtB;;;;;kIAKgI;;EAEhI,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA,mEAAmE;AACnE;EACE,6BAA6B;AAC/B;;AAEA;EACE,yFAAyF;EACzF,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,YAAY;EACZ,4CAA4C;EAC5C,sDAAsD;EACtD,mBAAmB;EACnB,kCAAkC;EAClC,gFAAgF;EAChF,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,iCAAiC;EACjC,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE;IACE,QAAQ;IACR,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF","sourcesContent":["@import '../_base.css';\n@import '../../ui/styles/tavern-components.css';\n\n/* ========== Events Dashboard - Tavern Theme ========== */\n\n.events-dashboard {\n  padding: var(--space-4);\n  max-width: 960px;\n  margin: 0 auto;\n}\n\n.events-dashboard-header {\n  display: flex;\n  align-items: center;\n  gap: var(--space-4);\n  flex-wrap: wrap;\n  margin-bottom: var(--space-4);\n}\n\n.events-dashboard-title {\n  font-family: var(--font-heading);\n  font-size: 18px;\n  font-weight: var(--font-weight-bold);\n  color: var(--color-fire-600);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.events-create-button {\n  margin-left: auto;\n  font-size: 14px;\n  padding: 10px 16px;\n  height: auto;\n  width: auto;\n  white-space: nowrap;\n}\n\n/* Date Range Controls */\n.events-date-range,\n.date-range-control {\n  background: var(--color-wood-800);\n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n  padding: var(--space-2) var(--space-3);\n  /* margin-bottom: var(--space-4); */\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n.events-date-range-info,\n.date-range-text {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--color-parchment-100);\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n  font-family: var(--font-heading);\n}\n\n.date-range-button {\n  background: var(--color-wood-700);\n  border: 2px solid var(--color-wood-600);\n  color: var(--color-parchment-200);\n  padding: var(--space-2) var(--space-3);\n  border-radius: var(--radius-md);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.date-range-button:hover {\n  background: var(--color-wood-600);\n  border-color: var(--color-fire-600);\n}\n\n.date-range-button--today {\n  background: var(--color-fire-700);\n  border-color: var(--color-fire-600);\n  color: var(--color-parchment-100);\n}\n\n.date-range-button--today:hover {\n  background: var(--color-fire-600);\n  border-color: var(--color-fire-500);\n}\n\n@media (max-width: 425px) {\n  .events-date-range {\n    flex-direction: column;\n  }\n  \n  .events-date-range .tavern-btn-secondary {\n    width: 100%;\n  }\n}\n\n/* Events Content */\n.events-content {\n  min-height: 300px;\n}\n\n/* Day Header */\n.day-header {\n  background: var(--color-wood-800);\n  color: var(--color-parchment-100);\n  font-family: var(--font-heading);\n  font-size: 18px;\n  font-weight: 600;\n  padding: var(--space-3) var(--space-4);\n  border-radius: var(--radius-lg);\n  margin-top: var(--space-6);\n  margin-bottom: var(--space-4);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  cursor: pointer;\n  user-select: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all var(--transition-fast);\n}\n\n.day-header-wrapper {\n  cursor: pointer;\n  position: relative;\n  /* Button reset for accessibility */\n  width: 100%;\n  border: none;\n  background: transparent;\n  padding: 0;\n  text-align: left;\n  font: inherit;\n}\n\n.day-header-arrow {\n  position: absolute;\n  right: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 24px;\n  font-weight: normal;\n  color: var(--color-fire-500);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);\n  transition: transform 0.3s ease;\n  z-index: 100;\n  pointer-events: none;\n  line-height: 1;\n}\n\n.day-header-arrow--collapsed {\n  transform: translateY(-50%) rotate(180deg);\n}\n\n.day-header:hover {\n  background: var(--color-wood-700);\n}\n\n.day-header::after {\n  content: '▼';\n  font-size: 14px;\n  transition: transform var(--transition-fast);\n}\n\n.day-header.collapsed::after {\n  transform: rotate(-90deg);\n}\n\n/* Day Content */\n.day-content {\n  max-height: 10000px;\n  overflow: hidden;\n  transition: max-height 0.4s ease-out, opacity 0.3s ease-out;\n  opacity: 1;\n}\n\n.day-content.collapsed {\n  max-height: 0;\n  opacity: 0;\n}\n\n/* Table Subheader */\n.table-subheader {\n  background: linear-gradient(135deg, var(--color-wood-700) 0%, var(--color-wood-800) 100%);\n  color: var(--color-parchment-100);\n  font-size: 16px;\n  font-weight: 700;\n  padding: var(--space-1) var(--space-2);\n  border: none;\n  border-left: 5px solid var(--color-fire-500);\n  margin: var(--space-1) 0 var(--space-1) var(--space-1);\n  border-radius: 12px;\n  cursor: pointer;\n  user-select: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all var(--transition-fast);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);\n  /* Button reset for accessibility */\n  width: calc(100% - var(--space-3));\n  text-align: left;\n  font-family: inherit;\n}\n\n.table-subheader:hover {\n  background: linear-gradient(135deg, var(--color-wood-600) 0%, var(--color-wood-700) 100%);\n  transform: translateX(4px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.15);\n}\n\n.table-subheader::after {\n  content: '▼';\n  font-size: 14px;\n  color: var(--color-fire-400);\n  transition: transform var(--transition-fast);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);\n}\n\n.table-subheader.collapsed::after {\n  transform: rotate(-90deg);\n}\n\n/* Table Content */\n.table-content {\n  margin-left: var(--space-4);\n  max-height: 10000px;\n  overflow: hidden;\n  transition: max-height 0.4s ease-out, opacity 0.3s ease-out;\n  opacity: 1;\n}\n\n@media (min-width: 768px) {\n  .table-content:not(.collapsed) {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: var(--space-3);\n    align-items: start;\n  }\n\n  .table-content .table-subheader,\n  .table-content .type-subheader {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (min-width: 1024px) {\n  .events-dashboard {\n    max-width: var(--content-max);\n    padding: var(--space-6) var(--space-7);\n  }\n\n  /* Карточки одного типа в день — в сетку, а не в одну растянутую колонку */\n  .type-content {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    gap: var(--space-4);\n    align-items: start;\n  }\n\n  .type-content > .tavern-card--event {\n    margin-bottom: 0;\n  }\n\n  .table-content:not(.collapsed) {\n    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\n  }\n}\n\n.table-content.collapsed {\n  max-height: 0;\n  opacity: 0;\n}\n\n/* Event Cards (from prototype) */\n.event-card {\n  background: var(--color-parchment-100);\n  \n  /* Parchment texture */\n  background-image: \n    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),\n    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),\n    radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%),\n    repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(139, 69, 19, 0.06) 2px, rgba(139, 69, 19, 0.06) 3px),\n    repeating-linear-gradient(90deg, transparent, transparent 100px, rgba(160, 82, 45, 0.03) 100px, rgba(160, 82, 45, 0.03) 101px);\n  \n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n  padding: var(--space-4);\n  margin-bottom: var(--space-3);\n  transition: all var(--transition-normal);\n}\n\n.event-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.event-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: var(--space-3);\n}\n\n.event-badges {\n  display: flex;\n  gap: var(--space-2);\n}\n\n.event-badge {\n  background: var(--color-wood-700);\n  color: white;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 4px 10px;\n  border-radius: 12px;\n  text-transform: uppercase;\n}\n\n.event-badge-open {\n  background: var(--color-success-500);\n}\n\n.event-time {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n}\n\n.event-title {\n  font-family: var(--font-heading);\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--color-fire-600);\n  margin-bottom: var(--space-2);\n}\n\n.event-organizer {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  margin-bottom: var(--space-3);\n}\n\n.event-slots {\n  border-top: 1px solid var(--color-wood-600);\n  padding-top: var(--space-3);\n}\n\n/* Type subheader (boardgames / ping_pong / fencing) within a day */\n.type-section {\n  margin-bottom: var(--space-3);\n}\n\n.type-subheader {\n  background: linear-gradient(135deg, var(--color-wood-700) 0%, var(--color-wood-800) 100%);\n  color: var(--color-parchment-100);\n  font-size: 15px;\n  font-weight: 700;\n  padding: var(--space-1) var(--space-2);\n  border: none;\n  border-left: 5px solid var(--color-fire-500);\n  margin: var(--space-1) 0 var(--space-1) var(--space-1);\n  border-radius: 12px;\n  width: calc(100% - var(--space-3));\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);\n}\n\n.type-content {\n  margin-left: var(--space-4);\n}\n\n/* Legacy compatibility classes */\n.ttbEventsDashboardPage {\n  padding: var(--space-4);\n  max-width: 960px;\n  margin: 0 auto;\n}\n\n.ttbSubTitle {\n  /* This is now replaced by tavern-table-header */\n  font-size: 14px;\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-secondary-light);\n}\n\n.ttbRangeControls {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  margin-bottom: var(--space-5);\n  padding: var(--space-4);\n  background: var(--color-wood-800);\n  border-radius: var(--radius-lg);\n  border: 2px solid var(--color-wood-700);\n}\n\n@media (max-width: 425px) {\n  .ttbEventsDashboardPage .ttbRangeControls {\n    gap: 8px;\n    flex-direction: column;\n  }\n\n  .ttbEventsDashboardPage .ttbRangeControls .ttbGrow {\n    flex-basis: 100%;\n    width: 100%;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
